module.exports = "/images/feather-sprite.svg?cbef33d25b84f027c6e7601fdec1f75a";